const WHITE_LIST = [
  'exchange-api',
  'assetWithdraw',
  'config',
  'api',
  'exchange',
  'public',
  'reInfo',
  'asset',
  'user',
  'private',
  'analytic',
  'charge',
  'withdraw',
  'fiatAssetCharge',
  'fiatAssetWithdraw',
  'jpush',
  'trade',
  'fiatBinding',
  'pnk-api',
  'dictionary',
  'info-api',
  'gateway-api',
  'kline',
  'inbox-api',
  'activity',
  'vote',
];

module.exports = {
  WHITE_LIST,
};
